import { userAvatarConfig } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { ActivityIndicator, Dimensions, Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Camera from '../../assets/icons/camera-filled.svg';
import PencilSimple from '../../assets/icons/pencilSimple.svg';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  onPress: () => void;
  base64Avatar?: string;
  loading: boolean;
  t: (key: string) => string;
}

export const AvatarPreviewEditButton: FunctionComponent<IProps> = (
  {
    onPress,
    base64Avatar,
    t,
    loading,
  },
) => {

  const containerContent = () => {
    if (loading) {
      return <ActivityIndicator
        size='small'
        color={Theme.PRIMARY}
        animating
      />;
    }

    if (base64Avatar) {
      return (
        <TouchableOpacity onPress={onPress}>
          <Image
            style={styles.image}
            source={{ uri: `data:image/png;base64,${base64Avatar}` }}
          />
          <TouchableOpacity style={styles.editButton} onPress={onPress}>
            <PencilSimple color={Theme.WHITE} height={defaultScale(20)} width={defaultScale(21)} />
          </TouchableOpacity>
        </TouchableOpacity>
      );
    }

    return (
      <>
        <Text style={styles.imageHeaderText}>{t('auth:appOnboardingAvatarTextAboveImage')}</Text>
        <TouchableOpacity onPress={onPress} style={styles.addImageButton}>
          <Camera color={Theme.GREY_FIGMA_MEDIUM_LIGHT} />
          <View style={[styles.editButton, { backgroundColor: Theme.PRIMARY }]}>
            <PencilSimple color={Theme.WHITE} height={defaultScale(20)} width={defaultScale(21)} />
          </View>
        </TouchableOpacity>
      </>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.contentBox}>
        {containerContent()}
      </View>
    </View>
  );
};

const { width } = Dimensions.get('window');
const contentBoxDims = Math.min(userAvatarConfig.dimensions.width, width * 0.75);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  contentBox: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 4,
    borderColor: Theme.GREY,
    width: contentBoxDims,
    height: contentBoxDims,
  },
  imageHeaderText: {
    ...Theme.textStyle.bodyCopyBold,
    marginBottom: defaultScale(20),
  },
  addImageButton: {
    height: defaultScale(140),
    width: defaultScale(140),
    borderRadius: defaultScale(140),
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Theme.GREY_FIGMA,
  },
  image: {
    width: contentBoxDims,
    height: contentBoxDims,
    borderRadius: 4,
  },
  editButton: {
    justifyContent: 'center',
    alignItems: 'center',
    height: defaultScale(33),
    width: defaultScale(33),
    borderRadius: 1000,
    borderWidth: defaultScale(2),
    borderColor: Theme.WHITE,
    position: 'absolute',
    bottom: defaultScale(5),
    right: defaultScale(5),
  },
});
